module.exports = __webpack_public_path__ + "img/banner_zhucan.ed589573.png";